import {IntermediatePart} from "../intermediatePart";
import store from "../../../../store";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {getFilterGroupValueByName, getFilterGroupValues} from "../../../../misc/utils";

export default class EdgeCommon extends IntermediatePart {

  constructor(props) {
    super(props);
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    const edgeFilterGroup = this.getEdgeFilterGroup();
    const countertop = this.getParent().countertop;

    // here we check if some countertop has the same name as currently active countertop & it has edge filter
    if (edgeFilterGroup && countertop && countertop.activeFeature) {
      featuresToDisplay = featuresToDisplay.map((feature) => {
        feature.notAvailableInVisualizer = !this.getMatchingCounterTop(feature);
        return feature
      });
    }

    if (edgeFilterGroup && (this.partId === "edge_profile")) { // Waterfall check for back countertop
      const waterFallFilter = getFilterGroupValueByName("Waterfall", edgeFilterGroup);
      if (waterFallFilter) {
        featuresToDisplay = featuresToDisplay.filter(feature => {
          const edgeFilters = getFilterGroupValues(feature, edgeFilterGroup)
          return !edgeFilters || !edgeFilters.includes(waterFallFilter.id)
        })
      }
    }

    return featuresToDisplay.map(_ => {
      const featurePart = new DesignNavigationItem(_.featureName, _);
      featurePart.notAvailableInVisualizer = featurePart.part.notAvailableInVisualizer;
      return featurePart
    });
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked);  // set active edge feature
    this.matchingCounterTop = this.getMatchingCounterTop();
    console.log("this.matchingCounterTop", this.matchingCounterTop);
    if (this.matchingCounterTop) {
      this.matchingCounterTop.handleClick(true);
    }
    this.featureClicked();
  }

  getMatchingCounterTop = (feature = this, countertopFeatures) => {
    const parent = feature.getParent();
    const countertop = parent.getParent().countertop;
    const edgeFilterGroup = feature.getEdgeFilterGroup();

    if (countertop && edgeFilterGroup) {
      const edgeFilterValue = feature.getEdgeFilterGroupFilters(feature, edgeFilterGroup);
      if (edgeFilterValue) {
        let matchingFeatures = (countertopFeatures || countertop.features).filter((feature) => {
          return (feature.dbFeature.filterValueIDs[edgeFilterGroup.id]
            && feature.dbFeature.filterValueIDs[edgeFilterGroup.id].some(edgeFilterId => {
              return edgeFilterValue.some(currentEdgeFilterId => currentEdgeFilterId === edgeFilterId)
            })) ||
            (feature.dbFeature.fabFilterValueIDs[edgeFilterGroup.id]
              && feature.dbFeature.fabFilterValueIDs[edgeFilterGroup.id].some(edgeFilterId => {
                return edgeFilterValue.some(currentEdgeFilterId => currentEdgeFilterId === edgeFilterId)
              }))
        });
        matchingFeatures = matchingFeatures.filter(feature => !feature.notAvailableInVisualizer)
        let matchingByName = feature.getMatchingCounterTopFeaturesBySplittedName(countertop, matchingFeatures);
        return matchingByName.length
          ? matchingByName[0]
          : matchingFeatures.length
            ? matchingFeatures[0]
            : null
      }
    }
    return null
  };

  getEdgeFilterGroupFilters = (feature, edgeFilterGroup) => {
    edgeFilterGroup = edgeFilterGroup || this.getEdgeFilterGroup();
    return getFilterGroupValues(feature, edgeFilterGroup)
  };

  getMatchingCounterTopFeaturesBySplittedName = (countertop, matchingFeatures = []) => {  // array of sorted by filter features
    if (!countertop.activeFeature) {
      return []
    }
    let currentActiveName = countertop.activeFeature.getCountertopGroupsSplittedFeatureName();
    return matchingFeatures.filter(feature => {
      const currentFeatureName = feature.getCountertopGroupsSplittedFeatureName();
      return currentFeatureName === currentActiveName
    })
  };

  getEdgeFilterGroup = () => {
    const filterGroups = store.getState().filterState.filterGroups;
    return filterGroups.find(group => group.name === "Edge" || group.name === "Edge Profile");
  };

  getArrayOfConditions() {
    return []
  }

  canUseNavigationFilterSteps() {
    return true
  }

  setLayers() {
    return false
  }

  setZIndex() {
    return false
  }

}
